<template>
  <a :class="{ disabled }" :href="href" @click.prevent="!disabled && $router.push(to)">
    <slot />
  </a>
</template>

<script>
import { isAuthorized } from '@/router'

// basically just a <router-link> tag but checking for authentication

export default {
  inject: ['companyUser'],
  props: {
    to: { type: [String, Object], required: true },
  },
  computed: {
    disabled() {
      // not authorized to click on the link
      return !isAuthorized(this.companyUser, this.$router.match(this.to))
    },
    href() {
      if (typeof this.to === 'object') {
        const route = this.$router.resolve(this.to)
        return route.href
      } else {
        return this.to
      }
    },
  },
}
</script>

<style scoped lang="scss">
.disabled {
  cursor: not-allowed;
  opacity: 0.8;
}
</style>
